import { LogicContext } from '@/logic/main/types';
import { openDeposit } from '@/model/account/kraken';

interface ExecuteBottomMenuCommandEvent {
  type: 'VIEW_BOTTOM_MENU_COMMAND_CLICK';
  payload: {
    command: string;
    itemTitle: string;
  };
}

export async function executeBottomMenuCommand(
  context: LogicContext,
  event: ExecuteBottomMenuCommandEvent
) {
  const { command } = event.payload;

  switch (command) {
    case 'deposit':
      await openDeposit();

      break;
    default:
      console.warn(`Unhandled command: ${command}`);
      break;
  }
}
